import { gql } from "@apollo/client";

export const SET_INVOICE_TAGS = gql`
  mutation setInvoiceTags($input: SetInvoiceTagsInput!) {
    invoice {
      setInvoiceTags(input: $input) {
        success
      }
    }
  }
`;
